// This icon file is generated automatically.
var PPointMapOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.88 10.38H1.12V.62A.13.13 0 001 .5H.12A.13.13 0 000 .63v10.74c0 .07.06.13.13.13h11.74c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13zM2.5 7.44a1 1 0 102 0 1 1 0 00-2 0zm1.84-3.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.81 7.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm2.32-4.9a.87.87 0 101.74 0 .87.87 0 00-1.74 0z", "fill-rule": "nonzero" } }] }, "name": "p-point-map", "theme": "outlined" };
export default PPointMapOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPointMapOutlined.js
// module id = 3546
// module chunks = 0